@if ($config()?.srcSet && $config()?.loaderParams) {
    <img [ngSrc]="$config().src"  [sizes]="$config().sizes" [ngSrcset]="$config().srcSet" [priority]="$config().priority"
         [fill]="$config().fill" [alt]="alt" [loaderParams]="$config().loaderParams" (load)="setLoaded($event)"
         [ngClass]="$config().cssClass" [width]="width" [height]="height"
    />
}
